$shm_hitalama_settings_git $mol_page
	title \Git-репозитории
	body /
		<= Hint $mol_text
			text \GitHub используется для хранения истории изменений приложений и их внутренних модулей, скиллов и руководства пользователя. Укажите токен и владельца репозиториев — пользователя или организацию. Сохранение в GitHub запускается кнопкой «Сделать коммит» в настройках соответствующего каталога или приложения.
		<= Token_label $mol_labeler
			title \GitHub токен
			Content <= Token $shm_hitalama_settings_agent_password
				input_name \hitalama_github_token
				value? <=> token? \
		<= Owner_label $mol_labeler
			title \Владелец GitHub: пользователь или организация
			Content <= Owner $mol_string
				hint \Имя пользователя или организации на GitHub
				value? <=> owner? \
